import { ActionTypesEngagement } from "../constants/action-types";
import { socket  } from "../../utils"

const createEngagementRequest =()=>{
    return {
        type: ActionTypesEngagement.CREATE_ENGAGEMENT_REQUEST
    }
}

const createEngagementError =(err)=>{
    return {
        type: ActionTypesEngagement.CREATE_ENGAGEMENT_ERROR,
        payload:{
            error:err
        }
    }
}

export const createEngagementSuccess = (data)=>{
    return {
        type: ActionTypesEngagement.CREATE_ENGAGEMENT_SUCCESS,
        payload:{
            data
        }
    }
}

export const createEngagement = (reqPayload)=>{
    
    return async (dispatch,getState)=>{
        dispatch(createEngagementRequest())
            let payload = {...reqPayload,contextParameters:getState()?.engagement?.params}
            let s = socket.getInstance()
            
            // dispatch(createEngagementSuccess({}))
            s.emit("createEngagement",payload,(data)=>{
                
                dispatch(createEngagementSuccess({}))
            })



    }
} 


